import axios from "axios";
import { adapterItemResponse } from "./adapters/adapterItem";
import { IRecord } from "../interfaces/interfaces";

export const updateRecordInDb = async (dataRecord: IRecord) => {
  try {
    let updateRecord: any = await axios({
      method: "put",
      url: "/api/edit-record",
      data: dataRecord,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error.data;
      });
    if (updateRecord.update === true) {
      let adaptedResponse = adapterItemResponse(updateRecord);
      return adaptedResponse;
    }
    if (updateRecord.update === false) {
      return false;
    }
    return false;
  } catch (error) {
    return false;
  }
};
